<template>
    <mds-layout-grid>
        <mds-row>
            <mds-col :cols="12">
                <slot name="header"></slot>
            </mds-col>
        </mds-row>
        <mds-row>
            <mds-col :cols="12">
                <slot></slot>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "base-layout",
    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    }
};
</script>
